// extracted by mini-css-extract-plugin
module.exports = {"container":"WhaleWhitepaper_container__3kqQY"};